<!-- Calendar + Customer converge on the shared member login panel (#1929): identical
     look, feel, and content. Only the admin portal keeps a distinct staff sign-in
     (no self-serve signup, no member-benefits pitch). Auth0 client config and the
     post-login return URL stay per-app in the smart container below. -->
@if (isAdminPortal()) {
  <section class="abx-login">
    <div class="abx-login__bg" aria-hidden="true"></div>

    <div class="abx-login__card">
      <a routerLink="" class="abx-login__brand" aria-label="AppliedBioX home">
        <bodyanalytics-brand-logo [variant]="theme.isDark() ? 'dark' : 'light'" [height]="40" />
      </a>

      <div class="abx-login__grid">
        <div class="abx-login__panel abx-login__panel--action">
          <div class="eyebrow abx-login__eyebrow">Staff access</div>
          <h1 class="abx-login__heading">Sign in to the admin portal</h1>
          <p class="abx-login__sub">Manage testing events, bookings, and customer records.</p>
          <button type="button" class="btn btn-primary abx-login__cta" (click)="auth.loginWithRedirect()">
            Log in
          </button>
        </div>

        <!-- Staff greeting panel — fills the space the member-benefits pitch used
             to occupy before it was removed for admin/calendar (#1716). -->
        <aside class="abx-login__panel abx-login__panel--staff-greeting">
          <div class="eyebrow abx-login__eyebrow">Welcome back</div>
          <h2 class="abx-login__staff-greeting-title">Good {{ staffGreeting }}, team.</h2>
          <p class="abx-login__sub">Every session you run today becomes someone else's proof of progress.</p>
        </aside>
      </div>

      <a routerLink="" class="abx-login__back">← Back to home</a>
    </div>
  </section>
} @else {
  <bodyanalytics-member-login-panel [isDark]="theme.isDark()" (login)="auth.loginWithRedirect()" />
}
